// Below-the-fold enters: [data-reveal] elements fade/slide in the first time
// they approach the viewport. Reveal fires as soon as any pixel crosses a
// line 8% above the bottom edge (threshold 0), so a tall element never sits
// invisible waiting to be "15% visible" — the cause of blank gaps mid-scroll.
// Put data-reveal on headings, cards and rows, not on whole sections.
// Staggered 60ms per element in a batch, or data-reveal-delay="ms" per item.
// Respects prefers-reduced-motion (CSS already renders those elements visible).
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
const items = document.querySelectorAll("[data-reveal]")

if (items.length && !reduceMotion && "IntersectionObserver" in window) {
  const STAGGER_MS = 60
  const MAX_STAGGER = 5
  let batchIndex = 0

  const reveal = (el) => {
    el.classList.add("is-revealed")
    el.addEventListener("transitionend", () => { el.style.transition = "none" }, { once: true })
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting)
      visible.forEach((entry) => {
        const ownDelay = Number(entry.target.dataset.revealDelay) || 0
        entry.target.style.transitionDelay = `${ownDelay + Math.min(batchIndex, MAX_STAGGER) * STAGGER_MS}ms`
        batchIndex++
        reveal(entry.target)
        observer.unobserve(entry.target)
      })
      if (visible.length) setTimeout(() => { batchIndex = 0 }, 400)
    },
    { threshold: 0, rootMargin: "0px 0px -8% 0px" }
  )
  items.forEach((item) => observer.observe(item))

  // Safety net: a background-tab load can make the observer skip its initial
  // check, leaving in-viewport elements invisible forever. Force-reveal
  // anything already on screen now, on tab focus, and after a timeout.
  const revealIfInViewport = () => {
    items.forEach((item) => {
      if (item.classList.contains("is-revealed")) return
      const rect = item.getBoundingClientRect()
      if (rect.top < window.innerHeight + 40 && rect.bottom > -40) {
        reveal(item)
        observer.unobserve(item)
      }
    })
  }
  requestAnimationFrame(revealIfInViewport)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") revealIfInViewport()
  })
  setTimeout(revealIfInViewport, 1500)
} else {
  items.forEach((item) => item.classList.add("is-revealed"))
}
